import React from "react";
import VarietyItem from "./variety-item";

const VarietiesTable = ({ attributeList, varieties, varietyData, varietiesWithLinks, handleClose, upc }) => {
    return (
        <div className="variety-packs">
            <div className="variety-table" style={{ gridTemplateRows: `85px 85px repeat(${attributeList.length}, 1fr)` }}>
                <div className="variety-info" style={{ display: "flex", border: 0 }}>
                    <button className="button" onClick={handleClose}>
                        Back
                    </button>
                    <h1>
                        Variety Packs <em className="memo">{upc}</em>
                    </h1>
                </div>
                <div className="variety-add">
                    <h3>Varieties</h3>
                </div>
                {attributeList.map((attr) => {
                    return <div key={`label_${attr.uuid}`}>{attr.name}</div>;
                })}
                {Object.keys(varietyData).map((v) => (
                    <VarietyItem
                        key={varietyData[v].code}
                        id={varietyData[v].code}
                        linkCode={varietyData[v].linkCode}
                        isParent={varietyData[v].childLinks && varietyData[v].childLinks.length > 0}
                        sharedValues={varietyData[v].sharedValues}
                        name={varietyData[v].variety}
                        referenceVariety={varietyData[v].referenceVariety}
                        packAttributes={varietyData[v].packAttributes}
                        attributeList={attributeList}
                        varieties={varieties}
                        varietiesWithLinks={varietiesWithLinks}
                    />
                ))}
            </div>
        </div>
    );
};

export default VarietiesTable;
